import { Grid, SxProps, Theme } from "@mui/material";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import {
  CHART_COLORS,
  CHART_TYPOGRAPHY,
} from "@/components/app/provider/patient/chart";
import { SESSION_INFO_EMPTY_VALUE } from "../group-visit-constant";
import { GroupActivityOption } from "../group-visit-types";

export type SelectedValuesListProps = {
  label: string;
  items: GroupActivityOption[];
  sx?: SxProps<Theme>;
};

/**
 * A multi-select's chosen values as a read-only list under its label, for
 * view mode.
 *
 * @author Rajkumar Rathod
 */
const SelectedValuesList = ({ label, items, sx }: SelectedValuesListProps) => (
  <Flex flexDirection="column" gap={0.5} width="100%" sx={sx}>
    <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textMutedGrey}>
      {label}
    </Text>
    {items.length === 0 ? (
      <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textDarker}>
        {SESSION_INFO_EMPTY_VALUE}
      </Text>
    ) : (
      <Grid container spacing={0.2} component="ul" sx={{ m: 0, p: 0 }}>
        {items.map((item) => (
          <Grid
            key={item.value}
            component="li"
            sx={{ listStyle: "none" }}
            size={{ xs: 12, sm: 6, md: 4 }}
          >
            <Text {...CHART_TYPOGRAPHY.body5} c={CHART_COLORS.textDarker}>
              {`• ${item.label}`}
            </Text>
          </Grid>
        ))}
      </Grid>
    )}
  </Flex>
);

export default SelectedValuesList;
